import React, { use, useEffect, useState, useRef } from "react";
import { Col, Row, Button, Form, Modal } from "react-bootstrap";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { getEventCollection } from "../../actions";
import { connect } from "react-redux";
import { loader } from "../../loader";
import { uploadImageToServer } from "../surveybuilder/CommonFunctions/CommonFunction";
import QuestionEditor from "../surveybuilder/SurveyComponents/QuestionEditor";
import { toast } from "react-toastify";


let eventsetupData = {};
const EventCollectionPage = (props) => {
    let path_image = process.env.REACT_APP_ASSETS_PATH_INFORMED_DESIGN;
    const containerRef = useRef(null);
    const customHtml = `<div class="registration-collection">
    <div class="registration-collection-header d-flex align-items-center" style="{#dynamic_header_background#};">
        <div class="collection-logo">
        {#logo#}
        </div>
        <div class="collection-content ">
        <h2 style="color: {#headerTextColor#};">{#headerText#}</h2>
        <Button style="color: {#buttonColor#};{#buttonColor_background#};">{#buttonText#}</Button>
        </div>
    </div>
    <div class="registration-collection-body">
        <div class="option-heading">
            <button class="btn btn-primary btn-bordered sort-button">Sort the content <img src="https://informed.pro/componentAssets/images/sort.svg" alt="" /></button>
        </div>
        <div class="registration-collection-inset">
        <h4 style="color: {#bodyTextColor#};">
            {#bodyText#}
        </h4>
        <div class="registration-collection-content">
            {#dynamicContent#}
        </div>
        </div>
    </div>
    <div class="footer-statement">
        <p style="color: {#footerTextColor#};">{#footerText#}</p>
    </div>
    </div>`;

    let defaultHtmlTokens = {
        dynamic_header_background: `background-image: url(${path_image}/registration-collection-header.png)`,
        headerTextColor: '#ffffff',
        buttonColor: '#ffffff',
        buttonColor_background: 'background-color:#0066BE',
        bodyTextColor: '#0066BE',
        footerTextColor: '#70899E',
        headerText: 'Click to register and receive the content described below',
        buttonText: 'Register',
        bodyText: '<strong>Docintel Portal</strong> is a free service intended for Health Care Professionals. <strong>Please review the content you will receive before registering.</strong>',
        footerText: 'The information in this asset has been developed for an international audience. Accordingly, it may contain information on products and/or indications that are not approved in your country. Please refer to your country-specific approved product labelling for important safety information before prescribing, as licenses and licensing conditions may vary from country to country.',
        logo: `<img src="${path_image}docintel-portal.png" alt="Logo" />`,
        selectedContent: eventsetupData?.setUpData?.selectedContent ? eventsetupData?.setUpData?.selectedContent : [],
    }

    let defaultFormValues = {
        headerBackType: 'image',
        headerBackgroundColor: '#004A89',
        headerBackgroundImage: `${path_image}/registration-collection-header.png`,
        showHeaderLogo: true,
        headerLogoUrl: `${path_image}/docintel-portal.png`,
        headerLogoWidth: 100,
        headerText: 'Click to register and receive the content described below',
        headerTextColor: '#ffffff',
        buttonColor: '#ffffff',
        buttonColor_background: '#0066BE',
        buttonText: "Register",
        showBodySection: true,
        bodyText: '<strong>Docintel Portal</strong> is a free service intended for Health Care Professionals. <strong>Please review the content you will receive before registering.</strong>',
        bodyTextColor: '#0066BE',
        showFooterSection: true,
        footerText: 'The information in this asset has been developed for an international audience. Accordingly, it may contain information on products and/or indications that are not approved in your country. Please refer to your country-specific approved product labelling for important safety information before prescribing, as licenses and licensing conditions may vary from country to country.',
        footerTextColor: '#70899E',
    };
    const navigate = useNavigate();
    const [htmlTokens, setHtmlTokens] = useState([]);
    const [formValues, setFormValues] = useState(eventsetupData?.setUpData?.formData ? eventsetupData?.setUpData?.formData : defaultFormValues);

    const [show, setShow] = useState(false);
    const [items, setItems] = useState(eventsetupData?.setUpData?.selectedContent);
    const [draggedIndex, setDraggedIndex] = useState(null);
    const handleShow = () => setShow(true);
    const handleClose = () => setShow(false);

    useEffect(() => {
        if (eventsetupData?.setUpData?.templateHtml) {
            const updatedTemplateHtml = {
                ...eventsetupData.setUpData.templateHtml,
                selectedContent: eventsetupData?.setUpData?.selectedContent ? eventsetupData?.setUpData?.selectedContent : [],
            };
            setHtmlTokens(updatedTemplateHtml);
        } else {
            setHtmlTokens(defaultHtmlTokens);
        }
    }, [eventsetupData]);


    const renderHtmlWithTokens = (template, tokens) => {
        let result = template;
        Object.entries(tokens).forEach(([key, value]) => {
            if (key !== 'selectedContent') {
                result = result.replaceAll(`{#${key}#}`, value);
            }
        });
        result = result.replace('{#dynamicContent#}', renderDynamicContent(tokens.selectedContent));
        return result;
    };

    const renderDynamicContent = (items = []) => {
        return items
            .map((item) => {
            return `
                <div class="registration-collection-content-box">
                <div class="collection-img">
                    <img src="${item?.cover_img}" alt="" />
                </div>
                <div class="collection-text">
                    <p>${item.title}</p>
                    <span>${item.pdf_sub_title}</span>
                    <div class="option-included"></div>
                </div>
                </div>
            `;
            })
            .join('');
    };

    const handleHeaderBackgroundTypeChange = (e) => {
        const value = e.target.value;

        setFormValues((prev) => ({
            ...prev,
            headerBackType: value,
        }));

        if (value === 'color') {
            setHtmlTokens((prev) => ({
            ...prev,
            dynamic_header_background: `background-color: ${formValues.headerBackgroundColor}`,
            }));
        } else if (value === 'image') {
            setHtmlTokens((prev) => ({
            ...prev,
            dynamic_header_background: `background-image: url(${formValues.headerBackgroundImage})`,
            }));
        }
    };

    const handleBackgroundColorChange = (e) => {
        const color = e.target.value;

        setFormValues((prev) => ({
            ...prev,
            headerBackgroundColor: color,
        }));

        setHtmlTokens((prev) => ({
            ...prev,
            dynamic_header_background: `background-color: ${color}`,
        }));
    };

    const handleImageUpload = async (e, type) => {
        const file = e.target.files[0];
        if (!file) return;
        try {
            loader("show");
            const result = await uploadImageToServer(file);
            const uploadedUrl = result;
            if (type === "headerBackground") {
                setFormValues((prev) => ({
                    ...prev,
                    headerBackgroundImage: uploadedUrl,
                }));

                setHtmlTokens((prev) => ({
                    ...prev,
                    dynamic_header_background: `background-image: url(${uploadedUrl})`,
                }));
            }else if (type === "headerLogo") {
                setFormValues((prev) => ({
                    ...prev,
                    headerLogoUrl: uploadedUrl,
                }));
                if (formValues.showHeaderLogo) {
                    setHtmlTokens((prev) => ({
                        ...prev,
                        logo: `<img src="${uploadedUrl}" style="width: ${formValues.headerLogoWidth}%;" alt="Logo" />`,
                    }));
                }
            }
        } catch (err) {
            console.error("Upload error:", err);
        } finally {
            loader("hide");
        }
    };

    const handleHeaderLogoToggle = (type) => {
        if(type == "headerLogo"){
            setFormValues((prev) => {
                const updated = { ...prev, showHeaderLogo: !prev.showHeaderLogo };
                const safeUrl = updated.headerLogoUrl?.replace(/"/g, '&quot;') || '';
                const safeWidth = parseInt(updated.headerLogoWidth, 10) || 100;
                setHtmlTokens((tokens) => ({
                ...tokens,
                logo: updated.showHeaderLogo
                    ? `<img src="${safeUrl}" style="width: ${safeWidth}%;" alt="Logo" />`
                    : "",
                }));
                return updated;
            });
        }else if(type == "bodySection"){
            setFormValues((prev) => {
                const updated = { ...prev, showBodySection: !prev.showBodySection };
                setHtmlTokens((tokens) => ({
                ...tokens,
                bodyText: updated.showBodySection
                    ? updated.bodyText
                    : "",
                bodyTextColor : updated.showBodySection
                    ? updated.bodyTextColor
                    : "",
                }));
                return updated;
            });
        }else if(type == "footerSection"){
            setFormValues((prev) => {
                const updated = { ...prev, showFooterSection: !prev.showFooterSection };
                setHtmlTokens((tokens) => ({
                ...tokens,
                footerText: updated.showFooterSection
                    ? updated?.footerText
                    : "",
                footerTextColor : updated.showFooterSection
                    ? updated?.footerTextColor
                    : "",
                }));
                return updated;
            });
        }
    };

    const handleWidthChange = (e, value) => {
        setFormValues((prev) => ({
            ...prev,
            headerLogoWidth: value,
        }));

        if (formValues.showHeaderLogo) {
            setHtmlTokens((prev) => ({
                ...prev,
                logo: `<img src="${formValues.headerLogoUrl}" style="width: ${value}%;" alt="Logo" />`,
            }));
        }
    };

    const cleanEditorHtml = (html) => {
        return html.replace(/^<p>(.*?)<\/p>$/i, '$1');
    };

    const handleTextChange = (field) => (value) => {
        const cleaned = cleanEditorHtml(value);
        setFormValues((prev) => ({ ...prev, [field]: cleaned }));
    };

    const handleColorChange = (field) => (e) => {
        setFormValues((prev) => ({ ...prev, [field]: e.target.value }));
    };

    useEffect(() => {
        setHtmlTokens((prev) => ({
            ...prev,
            ... {
                headerText: formValues.headerText,
                headerTextColor: formValues.headerTextColor,
            },
            ...(formValues.showBodySection && {
                bodyText: formValues.bodyText,
                bodyTextColor: formValues.bodyTextColor,
            }),
            ...(formValues.showFooterSection && {
                footerText: formValues.footerText,
                footerTextColor: formValues.footerTextColor,
            }),
            ...(formValues.buttonText && {
                buttonText: formValues.buttonText,
            }),
            ...(formValues.buttonColor_background && {
                buttonColor_background: `background-color:${formValues.buttonColor_background}`,
            }),
            ...(formValues.buttonColor && {
                buttonColor: formValues.buttonColor,
            }),
        }));
    }, [
        formValues.headerText,
        formValues.headerTextColor,
        formValues.buttonColor,
        formValues.bodyText,
        formValues.bodyTextColor,
        formValues.footerText,
        formValues.footerTextColor,
        formValues.buttonText,
        formValues.buttonColor_background,
        formValues.showBodySection,
        formValues.showFooterSection,
    ]);

    useEffect(() => {
        const container = containerRef.current;
        if (!container) return;

        const sortButtons = container.querySelectorAll('.sort-button');
        sortButtons.forEach((btn) => {
          btn.addEventListener('click', handleShow);
        });

        return () => {
          sortButtons.forEach((btn) => {
            btn.removeEventListener('click', handleShow);
          });
        };
      }, [htmlTokens]);

    const createCollection = async() => {
        try{
            loader("show");
            const body = {
                templateHtml: htmlTokens,
                formData: formValues,
            };
            let updateArticleCollectionData = {
                ...eventsetupData,
                setUpData: {
                    ...eventsetupData?.setUpData,
                    ...body,
                },
            };
            await props.getEventCollection(updateArticleCollectionData);
            navigate("/webinar/event/event-collection-registration")
        }catch(err){
            console.log(err)
            toast.warning("Something went wrong");
        }finally{
            loader("hide");
        }
    }

    const onDragStart = (index) => {
        setDraggedIndex(index);
    };

    const onDragOver = (e) => {
        e.preventDefault();
    };

    const onDrop = (index) => {
        if (draggedIndex === null || draggedIndex === index) return;

        const newItems = [...items];
        const [draggedItem] = newItems.splice(draggedIndex, 1);
        newItems.splice(index, 0, draggedItem);

        setItems(newItems);
        setDraggedIndex(null);
    };

    const saveOrder = async () => {
        try {
            if (eventsetupData && eventsetupData.setUpData) {
                eventsetupData.setUpData.selectedContent = [...items];
                setHtmlTokens((prev) => ({
                    ...prev,
                    selectedContent: [...items],
                }));
            }
            handleClose();
        } catch (err) {
            console.log(err,"Error saving order.");
        }
    };

    return (
        <>
            <meta name="viewport" content="width=device-width, initial-scale=1" />
            <Col className="right-sidebar custom-change event-collection">
                <div className="container-fluid">
                    <div className="row">
                        <div className="top-right-action preview">
                            <div className="d-flex flex-column w-100">
                                <div className="page-top-nav sticky">
                                    <Row className="justify-content-end align-items-center">
                                        <Col md={1}>
                                            <div className="header-btn-left">
                                                <button className="btn btn-primary btn-bordered back" onClick={(e) => {
                                                    e.preventDefault();
                                                    navigate("/webinar/event/event-collection-content");
                                                }}>
                                                    Back
                                                </button>
                                            </div>
                                        </Col>
                                        <Col md={9}>
                                            <ul className="tabnav-link">
                                                <li className="">
                                                    <Link to="">Select your content collection</Link>
                                                </li>
                                                <li className="active active-main">
                                                    <Link to="">Set-up collection page</Link>
                                                </li>
                                                <li className="">
                                                    <Link to="">Set-Up Registration pop-up</Link>
                                                </li>
                                            </ul>
                                        </Col>
                                        <Col md={2}>
                                            <div className="header-btn">
                                                <Link className="btn btn-primary btn-bordered move-draft"
                                                    to="/webinar/event/event-collection">
                                                    Cancel
                                                </Link>
                                                <Button className= {`btn btn-primary btn-filled next`} onClick={createCollection}>
                                                    Next
                                                </Button>
                                            </div>
                                        </Col>
                                    </Row>
                                </div>
                            </div>
                        </div>
                        <div className="setup-collection">
                            <div className="setup-collection-inset">
                        <div class="left-setup-heading"><h5>Set-up Your Content Collection Page</h5><p>By customizing the page to match your brand and content</p></div>
                            <div className="setup-collection-sidebar">
                                <div className="survey-active-data">
                                    <div className="steps">
                                        <div className="d-flex align-items-center">
                                            <p className="option-heading">
                                                Header background:
                                            </p>
                                            <div className="check-group">
                                                <Form.Group>
                                                    <label className="check">
                                                        Color
                                                        <input
                                                            type="radio"
                                                            name="headerBackType"
                                                            value="color"
                                                            checked={formValues.headerBackType === 'color'}
                                                            onChange={handleHeaderBackgroundTypeChange}
                                                        />
                                                        <span className="checkmark"></span>
                                                    </label>
                                                    <label className="check">
                                                        Image
                                                        <input
                                                            type="radio"
                                                            name="headerBackType"
                                                            value="image"
                                                            checked={formValues.headerBackType === 'image'}
                                                            onChange={handleHeaderBackgroundTypeChange}
                                                        />
                                                        <span className="checkmark"></span>
                                                    </label>
                                                </Form.Group>
                                            </div>
                                        </div>
                                        {formValues.headerBackType === "image" ? (
                                            <div className="header-added">
                                                <div className="d-flex align-items-center">
                                                    <div className="img-added">
                                                        {
                                                            formValues?.headerBackgroundImage != ""
                                                            ?
                                                            <img src={formValues?.headerBackgroundImage} alt="" />
                                                            :
                                                            <img src={path_image + "add-img.png"} alt="" />
                                                        }
                                                    </div>
                                                    <div className="input-file-container">
                                                        <input type="file" name="file" className="input-file" onChange={(e) => handleImageUpload(e, "headerBackground")} 
                                                        />
                                                        <label
                                                            tabIndex="0"
                                                            htmlFor="my-file"
                                                            className="input-file-trigger"
                                                        >
                                                            + Add image
                                                        </label>
                                                        <br />
                                                        <span>Width: 1334px | Height: 270px</span>
                                                    </div>
                                                </div>
                                            </div>
                                          ) : (
                                            <Form.Group>
                                                <div className="color-picker">
                                                    <div className="color-pick">
                                                        <div className="color-pick-point">
                                                            <img src={path_image + "color-picker.svg"} alt=""/>
                                                        </div>
                                                        <input
                                                            type="color"
                                                            title="Choose your color"
                                                            name="color"
                                                            value={formValues.headerBackgroundColor}
                                                            onChange={handleBackgroundColorChange}
                                                       />
                                                    </div>
                                                </div>
                                            </Form.Group>
                                        )}
                                    </div>
                                    <div className="steps">
                                        <div className="d-flex align-items-center justify-content-between">
                                            <p className="option-heading">Header Logo</p>
                                            <Form.Check
                                                type="switch"
                                                id="custom-switch"
                                                checked={formValues.showHeaderLogo}
                                                onChange={(e) => handleHeaderLogoToggle("headerLogo")}
                                            />
                                        </div>
                                        {formValues.showHeaderLogo && (
                                            <>
                                                <div className="d-flex align-items-center">
                                                    <div className="img-preview header-logo">
                                                        {
                                                            formValues.headerLogoUrl != '' ?
                                                                <img src={formValues.headerLogoUrl} alt=""/>
                                                            :
                                                                <img src={path_image + "docintel-portal.png"} alt=""/>
                                                        }
                                                    </div>
                                                    <div className="input-file-container">
                                                        <input
                                                            type="file"
                                                            name="header_logo"
                                                            className="input-file"
                                                            onChange={(e) => handleImageUpload(e, "headerLogo")}
                                                        >
                                                        </input>
                                                        <label
                                                            tabIndex="0"
                                                            htmlFor="my-file"
                                                            className="input-file-trigger"
                                                        >
                                                            Change Logo
                                                        </label>
                                                        <br />
                                                        <span>
                                                            The recommended color is white
                                                        </span>
                                                    </div>
                                                </div>
                                                <div className="words-limit">
                                                    <p className="option-heading">
                                                        Logo Width (%)
                                                    </p>
                                                    <input
                                                        placeholder="20"
                                                        type="number"
                                                        className="form-control"
                                                        value={formValues.headerLogoWidth}
                                                        onChange={(e) => {
                                                            const value = Math.max(0, Math.min(100, parseInt(e.target.value, 10)));
                                                            handleWidthChange(e, value);
                                                        }}
                                                    />
                                                </div>
                                            </>
                                        )
                                        }
                                    </div>
                                    <div className="steps">
                                        <div className="d-flex align-items-center justify-content-between">
                                            <p className="option-heading">Header Title</p>
                                            {/* <Form.Check type="switch" id="custom-switch"/> */}
                                        </div>
                                        <div className="text-editor">
                                            <QuestionEditor
                                                value={formValues.headerText}
                                                handleUpdateElement={(index, field, value) =>
                                                    handleTextChange("headerText")(value)
                                                }
                                                index="0"
                                                Placeholder=""
                                                headingBoldFlag={0}
                                                showColor={1}
                                            />
                                        </div>
                                        <Form.Group>
                                            <Form.Label>Title Color</Form.Label>
                                            <div className="color-picker">
                                                <div className="color-pick">
                                                    <div className="color-pick-point">
                                                        <img src={path_image + "color-picker.svg"} alt=""/>
                                                    </div>
                                                    <input type="color"
                                                        title="Choose your color"
                                                        name="color"
                                                        value={formValues.headerTextColor}
                                                        onChange={handleColorChange('headerTextColor')}
                                                    />
                                                </div>
                                            </div>
                                        </Form.Group>
                                    </div>
                                    <div className="steps d-flex flex-row justify-content-start">
                                        <Form.Group className="multi-options">
                                            <Form.Label>Button Color</Form.Label>
                                            <div className="color-picker">
                                                <div className="color-pick">
                                                    <div className="color-pick-point">
                                                        <img src={path_image + "color-picker.svg"} alt=""/>
                                                    </div>
                                                    <input type="color"
                                                        title="Choose your color"
                                                        name="color"
                                                        value={formValues.buttonColor_background}
                                                        onChange={handleColorChange('buttonColor_background')}
                                                    />
                                                </div>
                                            </div>
                                        </Form.Group>
                                        <Form.Group className="multi-options">
                                            <Form.Label>Text Color</Form.Label>
                                            <div className="color-picker">
                                                <div className="color-pick">
                                                    <div className="color-pick-point">
                                                        <img src={path_image + "color-picker.svg"} alt=""/>
                                                    </div>
                                                    <input type="color"
                                                        title="Choose your color"
                                                        name="btn-color"
                                                        value={formValues.buttonColor}
                                                        onChange={handleColorChange('buttonColor')}
                                                    />
                                                </div>
                                            </div>
                                        </Form.Group>
                                        <Form.Group className="multi-options">
                                            <Form.Label>Button Text</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="button_text"
                                                placeholder="Enter button text"
                                                value={formValues.buttonText}
                                                onChange={(e) =>  handleTextChange("buttonText")(e?.target?.value)}
                                            />
                                        </Form.Group>
                                    </div>
                                    <div className="steps">
                                        <div className="d-flex align-items-center justify-content-between">
                                            <p className="option-heading">
                                                Body Text
                                            </p>
                                            <Form.Check type="switch"
                                                id="custom-body-switch"
                                                checked={formValues.showBodySection}
                                                onChange={(e) => handleHeaderLogoToggle("bodySection")}
                                            />
                                        </div>
                                        {
                                            formValues?.showBodySection && (
                                                <>
                                                    <div className="text-editor">
                                                        <QuestionEditor
                                                            value={formValues.bodyText}
                                                            handleUpdateElement={(index, field, value) =>
                                                                handleTextChange("bodyText")(value)
                                                            }
                                                            index="1"
                                                            Placeholder=""
                                                            headingBoldFlag={0}
                                                            showColor={1}
                                                        />
                                                    </div>
                                                    <Form.Group>
                                                        <Form.Label>Text Color</Form.Label>
                                                        <div className="color-picker">
                                                            <div className="color-pick">
                                                                <div className="color-pick-point">
                                                                    <img src={path_image + "color-picker.svg"} alt=""/>
                                                                </div>
                                                                <input type="color"
                                                                 title="Choose your color"
                                                                 name="color"
                                                                 value={formValues.bodyTextColor}
                                                                 onChange={handleColorChange('bodyTextColor')}
                                                                />
                                                            </div>
                                                        </div>
                                                    </Form.Group>
                                                </>
                                            )
                                        }
                                    </div>
                                    <div className="steps">
                                        <div className="d-flex align-items-center justify-content-between">
                                            <p className="option-heading">
                                                Footer Text
                                            </p>
                                            <Form.Check type="switch"
                                                id="custom-footer-switch"
                                                checked={formValues.showFooterSection}
                                                onChange={(e) => handleHeaderLogoToggle("footerSection")}
                                            />
                                        </div>
                                        {
                                            formValues.showFooterSection && (
                                                <>
                                                <div className="text-editor">
                                                    <QuestionEditor
                                                        value={formValues.footerText}
                                                        handleUpdateElement={(index, field, value) =>
                                                            handleTextChange("footerText")(value)
                                                        }
                                                        index="2"
                                                        Placeholder=""
                                                        headingBoldFlag={0}
                                                        showColor={1}
                                                    />
                                                </div>
                                                <Form.Group>
                                                    <Form.Label>Text Color</Form.Label>
                                                    <div className="color-picker">
                                                        <div className="color-pick">
                                                            <div className="color-pick-point">
                                                                <img src={path_image + "color-picker.svg"} alt=""/>
                                                            </div>
                                                            <input type="color"
                                                                title="Choose your color"
                                                                name="color"
                                                                value={formValues.footerTextColor}
                                                                onChange={handleColorChange('footerTextColor')}
                                                            />
                                                        </div>
                                                    </div>
                                                </Form.Group>
                                                </>
                                            )
                                        }
                                    </div>
                                </div>
                            </div>
                            </div>
                            <div ref={containerRef}
                            className="setup-collection-preview"
                                dangerouslySetInnerHTML={{
                                __html: renderHtmlWithTokens(customHtml, htmlTokens),
                                }}
                            />
                            {/* <div className="registration-collection">
                                <div className="registration-collection-header d-flex align-items-center">
                                    <div className="collection-logo">
                                        <img src={path_image + "docintel-portal.png"} alt="Logo" />
                                    </div>
                                    <div className="collection-content ">
                                        <h2>Click to register and receive the content described below</h2>
                                        <Button>Register</Button>
                                    </div>
                                </div>
                                <div className="registration-collection-body">
                                    <div className="registration-collection-inset">
                                        <h4><strong>Docintel Portal</strong> is a free service intended for Health Care Professionals. <strong>Please review the content you will receive before registering.</strong></h4>
                                        <div className="registration-collection-content">

                                            <div className="registration-collection-content-box">
                                                <div className="collection-img"><img src={path_image + "oxford-medical.png"} alt="" /></div>
                                                <div className="collection-text">
                                                    <p>First prospective report on immune tolerance in poor risk haemophilia A inhibitor patients with a single factor</p>
                                                    <span>Kreuz et al, 2015 Haemophilia</span>
                                                    <div className="option-included">
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="registration-collection-content-box">
                                                <div className="collection-img"><img src={path_image + "nuproviq.png"} alt="" /></div>
                                                <div className="collection-text">
                                                    <p>NuPreviq Study: Personalised prophylaxis with Nuwiq (simoctocog alfa) in adults with haemophilia A EBOOK SAMPLE</p>
                                                    <span>Infographics presented by Dr. Fernando Corrales EBO...</span>
                                                    <div className="option-included">
                                                        <img src={path_image + "video-img.png"} alt="Check" />
                                                        <span>Include videos </span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="registration-collection-content-box">
                                                <div className="collection-img"><img src={path_image + "8_check.png"} alt="" /></div>
                                                <div className="collection-text">
                                                    <p>8CHECK - F8 gene mutation analysis service</p>
                                                    <span>Collection, ISTH 2019, Melbourne AU</span>
                                                    <div className="option-included">
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="footer-statement">
                                    <p>The information in this asset has been developed for an international audience. Accordingly, it may contain information on products and/or indications that are not approved in your country. Please refer to your country-specific approved product labelling for important safety information before prescribing, as licenses and licensing conditions may vary from country to country.</p>
                                </div>
                            </div> */}
                        </div>
                    </div>
                </div>
            </Col>

            <Modal className="registration-collection-modal" show={show} onHide={handleClose} backdrop="static">
                <Modal.Header closeButton>
                    <Modal.Title>Reorder Items</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="registration-collection-content">
                        {items?.map((item, index) => (
                        <div
                            key={item.id}
                            className="registration-collection-content-box"
                            draggable
                            onDragStart={() => onDragStart(index)}
                            onDragOver={onDragOver}
                            onDrop={() => onDrop(index)}
                        >
                            <div className="collection-drag-icon d-flex align-items-center">
                            <img
                                src={path_image + "drag-drop-icon.svg"}
                                alt="" />
                                </div>
                            <div className="collection-img">
                            <img
                                src={item.cover_img}
                                alt=""
                            />
                            </div>
                            <div className="collection-text">
                            <p>{item.title}</p>
                            <span>{item.pdf_sub_title}</span>
                            <div className="option-included"></div>
                            </div>
                        </div>
                        ))}
                    </div>
                    </Modal.Body>
                <Modal.Footer>
                    <Button onClick={handleClose} className="btn-bordered">
                        Cancel
                    </Button>
                    <Button onClick={saveOrder} className="btn-filled">
                        Save Order
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
}

const mapStateToProps = (state) => {
    eventsetupData = state?.getEventCollection;
    return state;
};

export default connect(mapStateToProps, { getEventCollection: getEventCollection })(
    EventCollectionPage
);

